export const WORK_STATUSES_SET = 'at/userProfile/workStatuses/WORK_STATUSES_SET'
export const DEFAULT_WORK_STATUS_PLANNING_DATA_SET = 'at/userProfile/workStatuses/DEFAULT_WORK_STATUS_PLANNING_DATA_SET'
export const INITIAL_DEFAULT_WORK_STATUS_SET = 'at/userProfile/workStatuses/INITIAL_DEFAULT_WORK_STATUS_SET'




// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workStatuses/actionTypes.js